import { createAction } from 'typesafe-actions';
import { Statistics } from './types';

export const STATS_SET = 'STATS_SET';

export const setStats = createAction(STATS_SET)<Statistics>();
